import { ChangeRequestStatus } from '@account/meta/benefits-enrollment-meta';
import { BadgeType } from '@humi-design-library/components/Badge/types';
import { EmployeeDocument } from '@models/documents/employee-document.model';
import { Employee } from '@models/employee/employee.model';
import { Model } from '../core/base.model';

export class BenefitChangeRequest extends Model {
    protected static _resource = 'benefitManagement/companies/:company/benefitPlans/:benefitPlan/changeRequests';
    protected static _version = 'v2';
    protected static _type = 'changeRequests';

    protected static _serializeAttributes = [
        'employeesBenefitPlanId',
        'submittedAt',
        'adminNotes',
        'isAcknowledged',
        'status',
    ];

    protected static _datetimes = ['submittedAt', 'actionedAt'];

    get employeeDocument(): EmployeeDocument | null {
        return this.hasOne(EmployeeDocument, 'employeeDocument');
    }

    get employee(): Employee {
        return this.hasOne(Employee, 'employee');
    }

    get admin(): Employee {
        return this.hasOne(Employee, 'admin');
    }

    get employeesBenefitPlanId(): number {
        return this._attributes['employeesBenefitPlanId'];
    }

    set employeesBenefitPlanId(val: number) {
        this._attributes['employeesBenefitPlanId'] = val;
    }

    get submittedAt(): Date {
        return this._attributes['submittedAt'];
    }

    set submittedAt(val: Date) {
        this._attributes['submittedAt'] = val;
    }

    get adminNotes(): string {
        return this._attributes['adminNotes'];
    }

    set adminNotes(val: string) {
        this._attributes['adminNotes'] = val;
    }

    get isAcknowledged(): boolean {
        return this._attributes['isAcknowledged'];
    }

    set isAcknowledged(val: boolean) {
        this._attributes['isAcknowledged'] = val;
    }

    get actionedAt(): Date {
        return this._attributes['actionedAt'];
    }

    get status(): ChangeRequestStatus {
        return this._attributes['status'];
    }

    set status(status: ChangeRequestStatus) {
        this._attributes['status'] = status;
    }

    get getBadgeType(): BadgeType {
        if (this.status === ChangeRequestStatus.accepted) {
            return 'success';
        }
        if (this.status === ChangeRequestStatus.declined) {
            return 'danger';
        }
        return 'warning';
    }

    approve(): Promise<any> {
        this.status = ChangeRequestStatus.accepted;
        return this.save();
    }

    decline(): Promise<any> {
        this.status = ChangeRequestStatus.declined;
        return this.save();
    }

    isPending(): boolean {
        return this.status === ChangeRequestStatus.pending;
    }

    isAccepted(): boolean {
        return this.status === ChangeRequestStatus.accepted;
    }

    isDeclined(): boolean {
        return this.status === ChangeRequestStatus.declined;
    }
}
